import { gql } from "@apollo/client";



export const GET_APPLICANT_BY_ID = gql`
  query applicant($applicantId: String!) {
    applicant(applicantId: $applicantId) {
      applicantId
      firstName
      lastName
      email
      phone
      gender
      address
      linkedInUrl
      interviewStatus
      orgId
      uploadResume
      role
      dateOfBirth
      createdAt
      education {
        primarySchool
        primaryPercentage
        primaryPassoutYear
        secondarySchool
        secondaryPercentage
        secondaryPassoutYear
        graduation
        graduationPercentage
        graduationPassoutYear
        certificates
        Id
      }
      employment {
        currentCompany
        skills
        currentDesignation
        companyEmail
        noticePeriod
        holdingAnyOffer
        currentLocation
        preferedLocation
        annualSalary
        industry
        totalWorkExp
        expectedCtc
        functionalArea
        totalWorkExp
        uploadResume
        employmentId
        lastWorkingDay
        packageOffered
        isCurrent
        remarks
      }
      process {
        JobId
        applicantId
        interview {
          status
          jobId
          Id
          comment
          recruiter
        }
        jobtitles {
          jobId
          recruiter
          client
          jobTitle
        }
        placementDetails {
          jobId
          joiningStatus
        }
      }
      questionaires {
        applicantId
        jobId
        questionary
      }
      interviewPerformance {
        Id
        applicantName
        position
        interviewDate
        interviewerName
        performanceDetails
        interviewLevel
        templateId
        createdAt
      }
      interview {
        jobId
        status
        applicantId
        Id
      }
    }
  }
`;



export const APPLICANTS_BY_ORG = gql`
  query applicantsByOrg($orgId: Int) {
    applicantsByOrg(orgId: $orgId) {
      applicantId
      firstName
      lastName
      email
      phone
      gender
      address
      linkedInUrl
      createdAt
      interviewStatus
      orgId
      employment {
        currentCompany
        skills
        currentDesignation
        companyEmail
        noticePeriod
        holdingAnyOffer
        currentLocation
        preferedLocation
        annualSalary
        industry
        totalWorkExp
        expectedCtc
        functionalArea
        totalWorkExp
        uploadResume
        lastWorkingDay
        packageOffered
        employmentId
        isCurrent
      }
      process {
        JobId
        applicantId
        interview {
          status
          jobId
          Id
        }
        jobtitles {
          jobId
          recruiter
          client
          recruiter
        }
      }
    }
  }
`;




export const CREATE_APPLICANT = gql`
  mutation CreateApplicant($input: createApplicantInput) {
    createApplicant(input: $input) {
      applicantId
    }
  }
`;
export const ADD_APPLICANT = gql`
  mutation addApplicant($input: addApplicantInput) {
    addApplicant(input: $input) {
      applicantId
    }
  }
`;






export const UPDATE_PERSONALAPPLICANT = gql`
  mutation updateApplicant($input: updateApplicantInput) {
    updateApplicant(input: $input)
  }
`;






